































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import moment from "moment";
import BaseSuketCard from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/BaseSuketCard.vue";
import { SuketBase, SuketBaseWithRelationship } from "@/types/suket_sehat_paru";
import StoreSuketSehatParu from "@/store/modules/SuketSehatParu";
import SuketSehatParu from "@/services/SuketSehatParu";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import SuketSehatParuInputCard from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/SuketSehatParuInputCard.vue";
import { storePasien } from "@/store/modules/pasien";
import BaseSuketTabPage from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/BaseSuketTabPage";
import CommonSuket, { EnSuketCategory } from "@/services/CommonSuket";

@Component({
  components: {
    CardModalTtd,
    BaseSuketCard,
    SuketSehatParuInputCard
  }
})
export default class SuketSehatParuTabPage extends BaseSuketTabPage {
  @Prop() readonly register!: string;

  expandInput = false;
  pageTab = "tab-soap";
  allowedUnit = ["17", "2Q", "2S"];
  modalTtd = false;

  suketCategory = EnSuketCategory.SehatParu;
  suketSvc = new CommonSuket(this.suketCategory);
  suketStore = StoreSuketSehatParu;

  get dataSuket(): SuketBaseWithRelationship {
    return StoreSuketSehatParu.suket;
  }

  get tglSurat() {
    return moment(this.dataSuket?.surat_date).format("DD-MM-YYYY");
  }

  get loadContent() {
    return StoreSuketSehatParu.loading;
  }

  get creatorUserId() {
    return this.dataSuket?.creator_user_id;
  }

  get signeeUserId() {
    return this.dataSuket?.signee_user_id;
  }

  get isReadOnly() {
    if (this.pageIsReadOnly()) return true;
    return !this.allowedUnit.includes(userModule.user.unit_id);
  }

  get pasien() {
    return storePasien.identitasPasien;
  }

  backPageSoap() {
    this.$emit("pageTab", this.pageTab);
  }

  print(id) {
    SuketSehatParu.print(id);
  }

  showInput() {
    this.expandInput = true;
  }

  closeInput() {
    this.expandInput = false;
  }

  showSignatureModal() {
    this.modalTtd = true;
  }

  passTtd(value) {
    appModule.setLoading(true);

    SuketSehatParu.sign(this.dataSuket.id, { password: value })
      .then(dt => {
        if (dt.status == 1) {
          appModule.NoticeDelay("Berhasil Tanda Tangan Surat Keterangan");
          appModule.addMsgTtd("");
          StoreSuketSehatParu.getSuketByRegister(this.register);
        } else {
          appModule.sendErrorAlert(dt.message);
        }
      })
      .finally(() => {
        appModule.setLoading(false);
        this.modalTtd = false;
      });
  }
}
